import { render } from "./SystemInformation.vue?vue&type=template&id=8d4fdca0&scoped=true&ts=true"
import script from "./SystemInformation.vue?vue&type=script&lang=ts"
export * from "./SystemInformation.vue?vue&type=script&lang=ts"

import "./SystemInformation.vue?vue&type=style&index=0&id=8d4fdca0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4fdca0"]])

export default __exports__